import type { CreateClientConfig } from '../generated/pm/client/types.gen';

/**
 * Runtime configuration for the generated PM (Partnership Management) client.
 * See `./pap.runtime.ts` for details on how this is wired up.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: '/api/ciam/pm',
});
